import {
  createContext,
  useReducer,
  ReactNode,
  useEffect,
  useContext,
} from 'react';
import { onAuthStateChanged } from 'firebase/auth';

import { authReducer } from './auth.reducer';
import { initialAuthState } from './auth.state';
import { AuthActionTypes, AuthContextType } from './auth.types';
import { auth } from '../../firebase';

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface Props {
  children: ReactNode;
}

export const AuthProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(authReducer, initialAuthState);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      dispatch({
        type: AuthActionTypes.SET_USER,
        payload: user,
      });
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuthContext must be used within AuthProvider');
  }

  return context;
};
